import { useQuery, UseQueryOptions , QueryKey} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PREDEFINED_TASKS_GET_BY_ID } from "./apiRoutes";

export interface PredefinedTaskResponse {
  data: PredefinedTask;
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  message: string;
}

export interface PredefinedTask {
  _id: string;
  taskName: string;
  taskCategory: {
    _id: string;
    name: string;
    description?: string;
    isActive: boolean;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
  priority: string;
  taskTerm: {
    _id: string;
    taskTerm: string;
    days?: number;
    isActive: boolean;
    createdBy: string;
    lastUpdatedBy?: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
  taskDescription?: string;
  isActive: boolean;
  createdBy: string;
  lastUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

const fetchPredefinedTaskById = async (id: string) => {
  const response = await axiosAuth.get<PredefinedTaskResponse>(
    `${PREDEFINED_TASKS_GET_BY_ID}${id}`
  );
  return response.data;
};

export const useGetPredefinedTaskByIdQuery = (
  id: string,
  options?: Omit<
  UseQueryOptions<PredefinedTaskResponse, Error, PredefinedTaskResponse>,
  "queryKey" | "queryFn"
>

) => {
  return useQuery({
    queryKey: ["predefinedTask", id],
    queryFn: () => fetchPredefinedTaskById(id),
    enabled: !!id,
    ...options,
  });
};
